<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="addNew"
      >
        新增用户角色
      </a-button>

      <a-form :form="pageSearchForm">
        <a-form-item :style="{ float: 'right' }">
          <a-select
            class="activity-config-search"
            :style="{
              marginTop: '19px',
              width: '120px',
              marginRight: '20px',
            }"
            v-decorator="[
              'platform_type',
              {
                initialValue: platform_type,
              },
            ]"
            :loading="loadingAuthGroup"
            placeholder="请选择平台"
            @change="handleChangePlatform"
          >
            <a-select-option key="pl" value="pl">平台端</a-select-option>
            <a-select-option key="cp" value="cp">药企端</a-select-option>
            <a-select-option key="sp" value="sp">服务商端</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div class="global-table-container">
      <a-table
        :pagination="showPagination"
        :columns="tableColumns"
        :dataSource="tableDataList"
        :rowSelection="rowSelection"
        :scroll="{ x: 900, y: 450 }"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            v-if="!record.status"
            type="primary"
            shape="round"
            size="small"
            @click.stop="handleSetStatus(record, 1)"
          >
            启用
          </a-button>
          <a-button
            v-if="record.status"
            type="dashed"
            shape="round"
            size="small"
            @click.stop="handleSetStatus(record, 0)"
          >
            禁用
          </a-button>
          <a-button
            size="small"
            type="primary"
            shape="circle"
            icon="eye"
            title="查看用户角色详情"
          ></a-button>
          <a-button
            size="small"
            title="修改用户角色"
            type="primary"
            shape="circle"
            icon="edit"
            @click.stop="handleEdit(record)"
          ></a-button>
          <!--
          <a-button
            size="small"
            title="删除用户角色"
            type="danger"
            shape="circle"
            icon="delete"
          ></a-button>
          -->
          <a-button
            type="primary"
            shape="round"
            size="small"
            @click.stop="bindAuthRule(record)"
          >
            权限配置
          </a-button>
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import updatePanel from "@/views/System/auth/authGroup/update.vue";
import authRulePanel from "@/views/System/auth/authGroup/authRule.vue";

var num = 0;
var pageContext;
export default {
  name: "AuthGroupList",
  data() {
    return {
      showPagination: false,
      pageSearchForm: this.$form.createForm(this),
      loadingAuthGroup: false,
      platform_type: "pl", //选择平台
      tableColumns: [],
      tableDataList: [],
      rowSelection: {
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(selectedRowKeys);
        },
      },
    };
  },
  mounted() {
    pageContext = this;
    pageContext.initColumns();
    pageContext.handleChangePlatform("pl");
  },
  methods: {
    initColumns() {
      pageContext.tableColumns = [
        {
          title: "角色名称",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "80px",
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: "100px",
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 280,
          scopedSlots: { customRender: "action" },
        },
      ];
    },
    async handleChangePlatform(value) {
      pageContext.loadingAuthGroup = true;
      pageContext.platform_type = value;
      pageContext.tableDataList = [];
      pageContext.refreshDataList();
    },
    async refreshDataList() {
      pageContext.$http
        .post("/AuthGroup/getDataList", {
          platform_type: pageContext.platform_type,
        })
        .then(function(response) {
          pageContext.loadingAuthGroup = false;
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.loadingAuthGroup = false;
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    addNew() {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "新 增",
            platform_type: pageContext.platform_type,
          },
        },
        area: ["450px", "350px"],
        title: "新增用户角色",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        },
      });
    },
    handleEdit(record) {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "保 存",
            itemData: record,
          },
        },
        area: ["450px", "350px"],
        title: "修改用户角色",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        },
      });
    },
    bindAuthRule(record) {
      pageContext.$layer.iframe({
        content: {
          content: authRulePanel,
          parent: this,
          data: {
            itemData: record,
          },
        },
        area: ["1000px", "650px"],
        title: "绑定权限菜单",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        },
      });
    },
    async handleSetStatus(record, status) {
      pageContext.$http
        .post("/AuthGroup/setStatus", {
          id: record.id,
          status: status,
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$message.success(response.data.msg);
            pageContext.refreshDataList();
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-circle {
    margin: 0px 5px;
  }
}
</style>
